export default "__VITE_ASSET__d5a8f2cc__"